import type { CaseLinks, LinkedCase } from '../../../../types/LegalCase';

// AF-3972 extensão (R2/R3): rótulo do caso vinculado e o texto dos dois sentidos, os mesmos no
// tooltip e no aria-label da grid e no bloco do detalhe. Puro e testável.
const SP_DATE = new Intl.DateTimeFormat('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
});

const withOperations = (head: string, linked: LinkedCase): string =>
    linked.operationsFormatted ? `${head} · op. ${linked.operationsFormatted}` : head;

export const linkedCaseLabel = (linked: LinkedCase): string => {
    if (linked.externalCaseNumber) return withOperations(linked.externalCaseNumber, linked);
    const openedOn = SP_DATE.format(new Date(linked.openedAt));
    return withOperations(`${linked.caseTypeFormatted} · aberto em ${openedOn}`, linked);
};

export const hasCaseLinks = (links?: CaseLinks | null): links is CaseLinks =>
    !!links && (!!links.escalatedFrom || links.escalatedTo.length > 0);

export const escalatedFromText = (links: CaseLinks): string | null =>
    links.escalatedFrom ? `Veio do caso ${linkedCaseLabel(links.escalatedFrom)}` : null;

export const escalatedToText = (links: CaseLinks): string | null =>
    links.escalatedTo.length > 0
        ? `Escalado para ${links.escalatedTo.map(linkedCaseLabel).join('; ')}`
        : null;

export const caseLinksDescription = (links: CaseLinks): string =>
    [escalatedFromText(links), escalatedToText(links)].filter(Boolean).join('. ');
